// extracted by mini-css-extract-plugin
export default {"listVariation":"AddVariationForm_listVariation__GjR77","customInput":"AddVariationForm_customInput__FkooR"};